export const TickmillAppBannerClosedKey = 'tickmillAppBannerClosed'
